<section class="container">
<div class="card">
    <div class="price">
        <p>{{packageName}}</p>

       <h2 *ngIf="packageShowPrice">{{packagePrice }} <span>EGP</span></h2> 

    </div>
    <div class="details">
        <div *ngFor="let service of packageServices; let last = last" [ngClass]="{'last-hr': last}">
            {{ service }}
            <hr>
          </div>
    </div>
</div>
</section>